<template>
  <div class="data-report">
    <el-row :gutter="20">
      <el-col :span="6">
        <el-card shadow="hover" class="stat-card">
          <div class="stat-icon" style="background: #409EFF;">
            <i class="el-icon-s-grid"></i>
          </div>
          <div class="stat-content">
            <div class="stat-value">{{ statistics.totalDevices }}</div>
            <div class="stat-label">设备总数</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover" class="stat-card">
          <div class="stat-icon" style="background: #67C23A;">
            <i class="el-icon-circle-check"></i>
          </div>
          <div class="stat-content">
            <div class="stat-value">{{ statistics.onlineDevices }}</div>
            <div class="stat-label">在线设备</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover" class="stat-card">
          <div class="stat-icon" style="background: #E6A23C;">
            <i class="el-icon-warning"></i>
          </div>
          <div class="stat-content">
            <div class="stat-value">{{ statistics.alarmCount }}</div>
            <div class="stat-label">告警数量</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover" class="stat-card">
          <div class="stat-icon" style="background: #F56C6C;">
            <i class="el-icon-error"></i>
          </div>
          <div class="stat-content">
            <div class="stat-value">{{ statistics.unhandledAlarms }}</div>
            <div class="stat-label">未处理告警</div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-card style="margin-top: 20px;">
      <div slot="header">
        <span>数据趋势</span>
      </div>
      <el-form :inline="true" size="small">
        <el-form-item label="时间范围">
          <el-select v-model="reportForm.dateRange" @change="handleDateChange">
            <el-option label="最近24小时" value="24h"></el-option>
            <el-option label="最近7天" value="7d"></el-option>
            <el-option label="最近30天" value="30d"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备">
          <el-select v-model="reportForm.deviceId" placeholder="请选择设备" clearable @change="handleDeviceChange">
            <el-option v-for="item in deviceOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
      </el-form>
      <div ref="chartRef" style="width: 100%; height: 400px;"></div>
    </el-card>

    <el-row :gutter="20" style="margin-top: 20px;">
      <el-col :span="12">
        <el-card>
          <div slot="header">
            <span>设备类型分布</span>
          </div>
          <div ref="pieChartRef" style="width: 100%; height: 300px;"></div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card>
          <div slot="header">
            <span>告警类型分布</span>
          </div>
          <div ref="alarmPieRef" style="width: 100%; height: 300px;"></div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import api from '@/api'

export default {
  name: 'DataReport',
  data() {
    return {
      statistics: {
        totalDevices: 0,
        onlineDevices: 0,
        alarmCount: 0,
        unhandledAlarms: 0
      },
      reportForm: {
        dateRange: '7d',
        deviceId: ''
      },
      deviceOptions: [],
      lineChart: null,
      pieChart: null,
      alarmPieChart: null
    }
  },
  mounted() {
    this.fetchStatistics()
    this.fetchDevices()
    this.$nextTick(() => {
      this.initCharts()
    })
  },
  beforeDestroy() {
    if (this.lineChart) this.lineChart.dispose()
    if (this.pieChart) this.pieChart.dispose()
    if (this.alarmPieChart) this.alarmPieChart.dispose()
  },
  methods: {
    async fetchStatistics() {
      try {
        const res = await api.getStatistics()
        this.statistics = res.data || {
          totalDevices: 0,
          onlineDevices: 0,
          alarmCount: 0,
          unhandledAlarms: 0
        }
      } catch (error) {
        console.error('获取统计数据失败:', error)
      }
    },
    async fetchDevices() {
      try {
        const res = await api.getDevices({ size: 100 })
        this.deviceOptions = res.data || []
      } catch (error) {
        console.error('获取设备列表失败:', error)
      }
    },
    handleDateChange() {
      this.initLineChart()
    },
    handleDeviceChange() {
      this.initLineChart()
    },
    handleQuery() {
      this.initLineChart()
    },
    initCharts() {
      this.lineChart = echarts.init(this.$refs.chartRef)
      this.pieChart = echarts.init(this.$refs.pieChartRef)
      this.alarmPieChart = echarts.init(this.$refs.alarmPieRef)
      this.initLineChart()
      this.initPieChart()
      this.initAlarmPieChart()
    },
    async initLineChart() {
      try {
        const params = {
          dateRange: this.reportForm.dateRange
        }
        if (this.reportForm.deviceId) {
          params.deviceId = this.reportForm.deviceId
        }
        
        const res = await api.getTrendData(params)
        
        const series = res.series.map(s => ({
          name: s.name,
          type: 'line',
          smooth: true,
          data: s.data,
          areaStyle: { opacity: 0.3 }
        }))
        
        const option = {
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data: res.series.map(s => s.name)
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: res.timeLabels
          },
          yAxis: {
            type: 'value',
            name: '数值'
          },
          series: series
        }
        this.lineChart.setOption(option)
      } catch (error) {
        console.error('获取趋势数据失败:', error)
      }
    },
    async initPieChart() {
      try {
        const res = await api.getDeviceTypeDistribution()
        
        const option = {
          tooltip: {
            trigger: 'item'
          },
          legend: {
            orient: 'vertical',
            left: 'left'
          },
          series: [
            {
              name: '设备类型',
              type: 'pie',
              radius: '50%',
              data: res || [],
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        }
        this.pieChart.setOption(option)
      } catch (error) {
        console.error('获取设备类型分布失败:', error)
      }
    },
    async initAlarmPieChart() {
      try {
        const res = await api.getAlarmTypeDistribution()
        
        const option = {
          tooltip: {
            trigger: 'item'
          },
          legend: {
            orient: 'vertical',
            left: 'left'
          },
          series: [
            {
              name: '告警类型',
              type: 'pie',
              radius: '50%',
              data: res || [],
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        }
        this.alarmPieChart.setOption(option)
      } catch (error) {
        console.error('获取告警类型分布失败:', error)
      }
    }
  }
}
</script>

<style scoped>
.stat-card {
  display: flex;
  align-items: center;
}

.stat-icon {
  width: 60px;
  height: 60px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
}

.stat-icon i {
  font-size: 28px;
  color: #fff;
}

.stat-content {
  flex: 1;
}

.stat-value {
  font-size: 28px;
  font-weight: bold;
  color: #303133;
}

.stat-label {
  font-size: 14px;
  color: #909399;
  margin-top: 4px;
}
</style>
